import { useSelector } from 'react-redux';
import { RoleObject } from '../../../global/models/authenticated-model';
import { TcsmStates } from '../../../root/tcsm-model';


export function useRoleObject() {

    const roleObject = useSelector<TcsmStates, RoleObject>(state => state.authenticatedState?.roleObject);

    return roleObject;
}